var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-table",on:{"touchstart":_vm.touchstart,"touchend":_vm.touchend}},[_c('div',{staticStyle:{"display":"none"}},[_vm._t("default")],2),_c('col-table-body',{attrs:{"data":_vm.data,"rows":_vm.rows,"columnWidth":_vm.columnWidth}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }